import {NgModule} from '@angular/core';
import {PagingControlComponent} from './paging-control.component';
import {LayoutModule} from '../../layout-components/layout.module';
import {CommonModule} from '@angular/common';

/**
 * Модуль элементов управления пагинацией
 */
@NgModule({
    imports: [
        LayoutModule,
        CommonModule,
    ],
    exports: [
        PagingControlComponent,
    ],
    declarations: [
        PagingControlComponent,
    ],
    providers: [],
})
export class PagingControlModule {
}
